import { render, staticRenderFns } from "./ComboBoostNotice.vue?vue&type=template&id=be5a4622&scoped=true&"
import script from "./ComboBoostNotice.vue?vue&type=script&lang=js&"
export * from "./ComboBoostNotice.vue?vue&type=script&lang=js&"
import style0 from "./ComboBoostNotice.vue?vue&type=style&index=0&id=be5a4622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5a4622",
  null
  
)

export default component.exports